import { ComputedCell, ConfirmCell } from '@morph-mapper/ui';
import { StyledItemRow } from './styles';
import { useItemEntryContext } from '../../context';
import { ActionCell } from '../action-cell';
import { ActionIcon, Box, Group, Table, Tooltip } from '@mantine/core';
import { LuIterationCw } from 'react-icons/lu';
import { useItemRowIterator } from './use-item-row-iterator';

interface ItemRowProps {
  editView?: React.ReactNode;
}

export const ItemRow = ({ editView }: ItemRowProps) => {
  const [
    id,
    name,
    computed,
    isConfirm,
    isEditing,
    cancelDelete,
    confirmDelete,
  ] = useItemEntryContext((s) => [
    s.getId(),
    s.getName(),
    s.getComputed(),
    s.isConfirm,
    s.isEditing,
    s.cancelDelete,
    s.confirmDelete,
  ]);
  const { hasIterator, isRoutable, openIterator } = useItemRowIterator(id);

  const pickCell = () => {
    if (isConfirm)
      return (
        <ConfirmCell handleAccept={confirmDelete} handleDeny={cancelDelete} />
      );

    return (
      <Group spacing="xs">
        {hasIterator && (
          <Tooltip
            label={
              hasIterator
                ? 'Open iterator'
                : 'Navigation disabled for this iterator'
            }
          >
            <ActionIcon
              variant="subtle"
              onClick={openIterator}
              disabled={!isRoutable}
            >
              <LuIterationCw size="1rem" />
            </ActionIcon>
          </Tooltip>
        )}
        <ComputedCell value={computed} />
      </Group>
    );
  };

  return (
    <>
      <StyledItemRow data-testid="entry-row" data-entry-name={name}>
        <td style={{ paddingRight: '3rem' }}>{name}</td>
        <td>{pickCell()}</td>
        <td style={{ whiteSpace: 'nowrap' }}>
          <ActionCell />
        </td>
      </StyledItemRow>
      {isEditing && (
        <tr>
          <td colSpan={3} style={{ border: 'none', padding: 0 }}>
            <Box
              sx={(theme) => ({
                display: 'flex',
                justifyContent: 'center',
                backgroundColor: theme.colors.gray[1],
                paddingTop: theme.spacing.md,
                paddingBottom: theme.spacing.md,
                paddingLeft: theme.spacing.xl,
                paddingRight: theme.spacing.xl,
                borderTop: `1px solid ${theme.colors.gray[3]}`,
              })}
            >
              <Table width={'100%'}>{editView}</Table>
            </Box>
          </td>
        </tr>
      )}
    </>
  );
};
